import PropTypes from 'prop-types';
import React from 'react';
import reactUpdate from 'react-addons-update';

import {CloudFunctionsClient} from '../../CloudFunctionsClient';
import {AddressFields, EMPTY_SHIPPING_ADDRESS} from '../../components/AddressFields';
import {db, getCurrentUserId, getCurrentUser} from '../../firebase';
import {saveStreetTeamOnboardingStep} from '../OnboardingSteps';

class CollectShippingAddress extends React.Component {
  constructor(props) {
    super(props);

    const initial_address = Object.assign({}, EMPTY_SHIPPING_ADDRESS, {
      name: getCurrentUser().displayName
    });

    this.state = {
      shippingAddress: initial_address
    };
  }

  submitShippingAddress = async() => {
    const userId = getCurrentUserId();

    const {shippingAddress} = this.state;

    await CloudFunctionsClient.post('/userApi-updateShippingAddress', {shippingAddress});

    saveStreetTeamOnboardingStep('Shipping Address', {
      shippingAddress,
    })

    const {onStepComplete} = this.props;
    onStepComplete();
  }

  render() {
    const {shippingAddress} = this.state;

    return (
      <div>
        <h2>
          Get Your Charging Cables
        </h2>

        <p>
          We use proprietary cables to charge our scooters. Give us your address and we
          will send you 3!
        </p>

        <AddressFields
          updateAddress={(new_obj) => {
            const new_shippingAddress = reactUpdate(shippingAddress, {$merge: new_obj});
            this.setState({shippingAddress: new_shippingAddress});
          }}
          {...shippingAddress}/>

        <button className="btn btn-primary" onClick={this.submitShippingAddress}>
          Send Them!
        </button>
      </div>
    )
  }
}

CollectShippingAddress.propTypes = {
  location: PropTypes.object.isRequired,
  onStepComplete: PropTypes.func.isRequired
}

export {CollectShippingAddress};



// WEBPACK FOOTER //
// ./src/street-team/onboarding/CollectShippingAddress.js